// Lightweight session cache so pages render instantly with last-known data and
// then refresh silently in the background -- no blocking "Loading..." screens.
// Backed by localStorage so data is also instant right after a page reload.

const MEM = {};
const PREFIX = "sx_cache_";

export function readCache(key, fallback) {
  if (Object.prototype.hasOwnProperty.call(MEM, key)) return MEM[key];
  try {
    const raw = localStorage.getItem(PREFIX + key);
    if (raw != null) {
      const value = JSON.parse(raw);
      MEM[key] = value;
      return value;
    }
  } catch (err) {}
  return fallback;
}

export function writeCache(key, value) {
  MEM[key] = value;
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(value));
  } catch (err) {}
}

// Fetch JSON while keeping a cached copy. Returns cached/fallback on failure.
export async function cachedFetchJson(key, url, fallback, options) {
  try {
    const res = await fetch(url, options);
    const data = await res.json();
    writeCache(key, data);
    return data;
  } catch (err) {
    const cached = readCache(key, undefined);
    return cached !== undefined ? cached : fallback;
  }
}
